import HorizontalSpacer from "../../../shared/HorizontalSpacer";
import LandingContentCard from "./LandingContentCard";
import LaptopMobile from "../../../shared/svg/laptop-mobile.svg";
import LandingPageMetricRow from "./LandingPageMetricRow";
import WidgetTeamLineUp from "../../../shared/WidgetTeamLineUp";
import commonUtils from "../../../shared/utils/commonUtils";
import LandingPageBlogCard from "./LandingPageBlogCard";

const LandingPageContent = () => {
  const bestTeam = commonUtils.getRandomNumbers(16, 1, 669);

  return (
    <>
      <section className="bg-hero-pattern bg-no-repeat bg-right-top bg-contain">
        <div className="p-4 pt-10 lg:px-12 lg:py-16 flex flex-col-reverse lg:flex-row">
          <div className="pt-5 lg:pr-12 lg:pt-0 w-full lg:w-5/12 ">
            <h1 className="text-center lg:text-left text-2xl lg:text-4xl font-extrabold font-arialb">
              Hey, how can we help you improve your squad?
            </h1>

            <HorizontalSpacer amount="10" />
            <LandingContentCard
              textContent={
                <>
                  Apply fix Artificial Intelligence to <b> optimize my Squad</b>
                </>
              }
              linkAddress="/#"
            />
            <HorizontalSpacer amount="4" />
            <LandingContentCard
              textContent={
                <>
                  Check player price predictions to{" "}
                  <b> increase my squad value</b>
                </>
              }
              linkAddress="/#"
            />

            <HorizontalSpacer amount="4" />
            <LandingContentCard
              textContent={
                <>
                  Use Opta Statistics to <b> identify key players</b>
                </>
              }
              linkAddress="/#"
            />

            <HorizontalSpacer amount="4" />
            <LandingContentCard
              textContent={
                <>
                  Check players predicted to <b> score high points returns</b>
                </>
              }
              linkAddress="/#"
            />
          </div>
          <div className="flex-grow w-full lg:w-7/12 flex items-center">
            <img src={LaptopMobile} alt="" />
          </div>
        </div>
      </section>
      <div className="w-full lg:py-10 lg:px-60 text-center">
        <h1 className="font-extrabold p-3 font-arialb text-2xl lg:text-4xl">
          All our latest content including our Gameweek 25 FPL Tips
        </h1>
      </div>

      <div className="lg:px-7 lg:pt-16 flex flex-col-reverse lg:flex-row">
        <LandingPageBlogCard
          title="GW24 Lessons Learned"
          imageUrl="https://loremflickr.com/320/240/epl"
          date="18. Feb. 21"
          summary="Fulham's Nigerian defender Aina tops the Custom Stats xFPL table
                for gameweek 24 with a whooping score of 18.5"
        />
        <div className="w-full lg:w-8/12 px-5 py-4">
          <div className="bg-white shadow-xl flex flex-col p-5">
            <div className="text-center py-5">
              <h1 className="font-extrabold p-1 font-arialb text-2xl lg:text-3xl">
                Gameweek 25 Algorithm Squad
              </h1>
            </div>
            <div className="flex-grow w-full flex flex-col lg:flex-row">
              <div className="w-full lg:w-1/2 flex-grow flex-shrink-0 relative ">
              
                <WidgetTeamLineUp team={bestTeam} />
              </div>
              <div className="flex-grow inline-flex flex-wrap w-full lg:w-1/2 text-center flex-shrink-0">
                <LandingPageMetricRow
                  text="Algorithm Picks Total Score"
                  value="34"
                />
                <LandingPageMetricRow
                  text="Average Points (Top 1k Managers)"
                  value="47.8"
                />
                <LandingPageMetricRow
                  text="Average Points (All Managers)"
                  value="41.1"
                />
                <LandingPageMetricRow
                  text="Average Players Played (All Managers)"
                  value="9.3"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="lg:px-7 lg:py-0 flex flex-wrap">
        <LandingPageBlogCard
          title="GW24 Lessons Learned"
          imageUrl="https://loremflickr.com/320/240/fifa"
          date="18. Feb. 21"
          summary="Fulham's Nigerian defender Aina tops the Custom Stats xFPL table
                for gameweek 24 with a whooping score of 18.5"
        />{" "}
        <LandingPageBlogCard
          title="GW24 Lessons Learned"
          imageUrl="https://loremflickr.com/320/240/epl"
          date="18. Feb. 21"
          summary="Fulham's Nigerian defender Aina tops the Custom Stats xFPL table
              for gameweek 24 with a whooping score of 18.5"
        />{" "}
        <LandingPageBlogCard
          title="GW24 Lessons Learned"
          imageUrl="https://loremflickr.com/320/240/uefa"
          date="18. Feb. 21"
          summary="Fulham's Nigerian defender Aina tops the Custom Stats xFPL table
            for gameweek 24 with a whooping score of 18.5"
        />
        <LandingPageBlogCard
          title="GW24 Lessons Learned"
          imageUrl="https://loremflickr.com/320/240/soccer"
          date="18. Feb. 21"
          summary="Fulham's Nigerian defender Aina tops the Custom Stats xFPL table
            for gameweek 24 with a whooping score of 18.5"
        />
        <LandingPageBlogCard
          title="GW24 Lessons Learned"
          imageUrl="https://loremflickr.com/320/240/premier%20league"
          date="18. Feb. 21"
          summary="Fulham's Nigerian defender Aina tops the Custom Stats xFPL table
            for gameweek 24 with a whooping score of 18.5"
        />
        <LandingPageBlogCard
          title="GW24 Lessons Learned"
          imageUrl="https://loremflickr.com/320/240/uefa"
          date="18. Feb. 21"
          summary="Fulham's Nigerian defender Aina tops the Custom Stats xFPL table
            for gameweek 24 with a whooping score of 18.5"
        />
      </div>
      <HorizontalSpacer amount="20" />

      <div className="lg:mx-12 py-10 flex flex-col lg:flex-row flex-wrap bg-gray-50">
        <div className="flex-grow text-center py-10  border-gray-300 border-r">
          <span className="font-extrabold font-arialb">
            <span className="text-violet-900">FPL Play</span>
            <span className="text-green-300" style={{ color: "#40fb0f" }}>
              ground
            </span>
          </span>
        </div>
        <div className="flex-grow inline-flex flex-col items-center justify-center text-center   border-gray-300 border-r">
          <a
            href="/#"
            className="py-2 px-4 font-bold uppercase text-xs  text-white bg-violet-1000 hover:bg-violet-900"
          >
            Join Our FPL League
          </a>

          <span className=" text-xs mt-4">
            <span className="uppercase">League Code: </span> 123456
          </span>
        </div>
        <div className="flex-grow text-center py-10  border-gray-300 border-r">
          <span className="font-extrabold font-arialb">
            <span className="text-violet-900">FPL Play</span>
            <span className="text-green-300" style={{ color: "#40fb0f" }}>
              ground
            </span>
          </span>
        </div>
      </div>
    </>
  );
};

export default LandingPageContent;
